export const BYTES = 'Byte Sequence'
